module.exports = __webpack_public_path__ + "img/icon_left.32879cd1.svg";